import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { States } from "app/_models/states";
import { CommonservicesService } from "app/_services/commonservices.service";
import { StateService } from "app/_services/state.service";
import { ToastrService } from "ngx-toastr";
declare const swal: any;

@Component({
  selector: "app-add-city",
  templateUrl: "./add-city.component.html",
})
export class AddCityComponent implements OnInit {
  addCityForm: UntypedFormGroup;
  state: States;
  states: States[];
  selectedStates: States[];

  constructor(
    private readonly toastr: ToastrService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly stateService: StateService,
    private readonly commonService:CommonservicesService,
    private readonly dialogRef: MatDialogRef<AddCityComponent>
  ) {}

  ngOnInit() {
    this.initilizeForm();
    this.getstates();
  }

  initilizeForm() {
    this.addCityForm = this.formBuilder.group({
      stateId: [null, [Validators.required]],
      cityName: [null, [Validators.required, Validators.maxLength(50)]],
    });
  }

  getstates() {
    this.stateService.getStates().subscribe((states) => {
      this.states = states;
      this.selectedStates = states;
    });
  }

  search(value: string) {
    let filter = value?.toLowerCase();
    if (!value) {
      return this.selectedStates;
    } else {
      this.selectedStates = [];
    }
  
    for (const state of this.states) {
      if (state.stateName.toLowerCase().includes(filter)) {
        this.selectedStates.push(state);
      }
    }
    return this.selectedStates;
  }
  
  

  saveCity() {
    let errorMessage = '';
    const stateId = this.addCityForm.value.stateId;
    const cityName = (this.addCityForm.value.cityName ?? '').trim();
    if (!cityName) {
      errorMessage += "City Name is required.\n";
    }
    if (cityName.length > 50) {
      errorMessage += "City Name cannot be more than 50 characters.\n";
    }
    if (!stateId || stateId == 0) {
      errorMessage += "State is required.\n";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }


    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Add IT!'
    }).then((result) => {
      if (result) {
        let model = {stateId: stateId, CityName: cityName};
        this.addSaveCity(model);
        
      }
      else {
        this.toastr.info('result not saved')
      }
    })

  }

  addSaveCity(model:any)
  {
    this.commonService.addCity(model).subscribe(
      data =>
      {
        if (data.didError) {
          swal({
            title: '',
            text: data.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info'
          });
        }
        else {
          swal({
            title: '',
            text: data.message,
            type: 'success',
            confirmButtonClass: 'btn btn-info'
          });
        }
        this.dialogRef.close(true);
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

        swal({
          title: '',
          text: errorMessage,
          type: 'error',
          confirmButtonClass: 'btn btn-info'
        });
      }
    )
  }

  close() {
    this.dialogRef.close(false);
  }
}
